import request from "./request";

// 获取玩法信息列表
export const getPlayInfoList = (param) => request("/playInfo/list", param, "GET");
// 修改玩法名称
export const updatePlayInfo = (data) => request("/playInfo/update", data, "POST");
// 添加玩法名称
export const addPlayInfo = (data) => request("//playInfo/add", data, "POST");
// 删除玩法
export const deletePlayInfo = (param) => request("/playInfo/delete", param, "GET");
// 投放负责人列表
export const geteaderList = () => request("/playInfo/leaderList", null, "GET");
